<template>
  <div class="about" >
    <el-container class="layout-container" >
      <!--头部信息-->
      <el-header class="el-header" >
        <div class="title">
          <span>ARENA</span>
        </div>

        <div class="guideMenu" >
          <el-menu class="el-menu"
                   background-color="#C6E2FF"
                   active-text-color="#606266"
                   mode="horizontal"
          >
            <el-submenu index="1">
              <template slot="title">Language</template>
              <el-menu-item class="guideMenu" index="1-1">
                <router-link tag='a' to="guide" style="color: #303133">
                  English
                </router-link>
              </el-menu-item>

              <el-menu-item class="guideMenu" index="1-2">
                <router-link tag='a' to="zh-cn/guide" style="color: #303133">
                  简体中文
                </router-link>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </div>

      </el-header>
      <!--      主题信息-->
      <el-main id="largeFont" class="el-main" style="height: 85vh">
        <el-steps :active="activeStep" finish-status="success">
          <el-step title="Step 1"></el-step>
          <el-step title="Step 2"></el-step>
          <el-step title="Step 3"></el-step>
          <el-step title="Step 4"></el-step>
          <el-step title="Step 5"></el-step>
        </el-steps>

        <el-card v-show="activeStep === 0" style="height: 60vh;margin-top: 40px;font-size: 18px">
          <p>
            Please follow this guide to complete the survey.
          </p>
          <p>
            For better presentation, please use PC.
          </p>
        </el-card>
        <el-card v-show="activeStep === 1" style="height: 60vh;margin-top: 40px;font-size: 18px">
          <ul>
            <li style="margin-bottom: 15px">
              Please refer to this
              <router-link tag='a' target='_blank' to="/" >
                link
              </router-link>
              to access the ARENA system.
            </li>
            <li style="margin-bottom: 15px">
              Refer to this
              <router-link tag='a' target='_blank' to="/about" >
                link
              </router-link>
              for help on how to use the ARENA system.
            </li>
          </ul>
          <div style="line-height: 40px">
          Firstly, please refer to the above two links to learn how to use the ARENA system.
          In particular, read the "how to use it" section of the help page carefully.
          <br>
          In this step, you don't need to think about how to complete the survey, you just need
          to be able to use the ARENA system.
          </div>
        </el-card>
        <el-card v-show="activeStep === 2" style="height: 60vh;margin-top: 40px;font-size: 18px;">
          <div style="text-align: center; margin-bottom: 20px">
            <img src="../assets/step4.jpg" class="image">
          </div>
          <div style="line-height: 40px">
            When you can use the ARENA system, please use the given SQL examples to view the best plan and
            corresponding alternative plans for different SQL.
            <br>
            Compare the difference between the alternative plans and the best plan and examine how these differences
            affect the Cost. Try to think about why.
          </div>
        </el-card>
        <el-card v-show="activeStep === 3" style="margin-top: 40px; font-size: 18px">
          <div style="text-align: center; margin-bottom: 20px">
            <img src="../assets/feedback.jpg" class="image">
          </div>
          <div style="line-height: 20px">
            <p>
              You have seen how to use the ARENA system using SQL examples and understood the the results it returns.
            </p>
            <p style="color: #409EFF">
              Now, please check carefully the results of "5.sql" and "6.sql" in the example, and send us the feedback, which
              is the main part of the survey.
            </p>
            <p>
              For each of these two SQLs(5.sql and 6.sql), you need to feed back the following information:
            </p>
            <ul>
              <li style="margin-bottom: 20px;color:#409EFF">
                The ID of the alternative plan you think is the most valuable and the reason.
              </li>
              <li style="color: #409EFF">
                The ID of the alternative plan you think is the least valuable and the reason.
              </li>
            </ul>
            <p style="font-size: 14px;text-indent: 20px;font-style: italic;color:#909399">
            (P.S. A plan is valuable if you can learn something through the difference between it and the best plan. If you can't learn anything, it's worthless.)
            </p>
            <p style="font-size: 14px;text-indent: 20px;font-style: italic;color:#409EFF">
              (P.S. When the page displays the results of 5.sql, the feedback information is associated with 5.sql. The same is true for 6.sql.)
            </p>
            <p>
              Fill this information into the form shown above and click the "submit" button to submit.
               For each of "5.sql" and "6.sql", you need to submit it once. If a duplicate submission is made
               to one of them, the previous feedback will be overwritten.
            </p>
            <p>
              *** This step is the key to the survey, please complete it carefully. ***
            </p>
          </div>
        </el-card>
        <el-card v-show="activeStep === 4" style="height: 60vh;margin-top: 40px">
          <div style="text-align: center; margin-bottom: 20px">
            <img src="../assets/suggest.jpg" class="image">
          </div>
          <p>
            Finally, if you have any suggestions for the ARENA system, please give us feedback through the section shown above. Any suggestions are welcome.
          </p>
          <p>
            Congratulations, you have completed the survey !
          </p>
        </el-card>
      </el-main>

      <el-footer class="footer">
        <el-form>
          <el-form-item>
            <el-button type="primary" style="width: 120px; margin-right: 40px" @click="previousStep">
              Previous Step
            </el-button>

            <el-button type="primary" style="width: 120px" @click="nextStep">
              Next Step
            </el-button>
          </el-form-item>
        </el-form>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "Guide",
  data() {
    return {
      activeStep: 0
    }
  },
  methods: {
    previousStep() {
      if (this.activeStep !== 0) {
        this.activeStep -= 1;
      }
    },

    nextStep() {
      if (this.activeStep < 4) {
        this.activeStep += 1
      }
    }
  }
}
</script>

<style scoped>
.layout-container .el-header {
  position: relative;
  background-color: #C6E2FF;
}

.layout-container .title{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 20px;
  color: #303133;
}

.layout-container .guideMenu{
  float: right;
}

.layout-container .el-footer {
  position: relative;
}

.guideMenu a {
  text-decoration: none;
}

.guideMenu .router-link-active {
  text-decoration: none;
}

</style>

<style>
.footer .el-form-item{
  text-align: center;
}

.guideMenu .el-submenu__title{
  font-size: 16px;
}

</style>
